import React from "react";

const Experimental = () => {
  return <h1>Experimental Page</h1>;
};

export default Experimental;